import { useMemo } from "react";
import { usePhytosanitaryProgramProgress } from "@/hooks/planning/phytosanitary-program/usePhytosanitaryProgram";

export const usePhytosanitaryProgress = (filtersForQuery, estate_id, estate_parent_id, isLoadingLookups, lookups) => {
	const queryFilters = useMemo(() => ({ ...filtersForQuery, estate_id, estate_parent_id }), [filtersForQuery, estate_id, estate_parent_id]);

	const isEnabled = useMemo(
		() => !isLoadingLookups && Boolean(lookups) && filtersForQuery.specie !== undefined && filtersForQuery.specie !== null && filtersForQuery.specie !== "",
		[isLoadingLookups, lookups, filtersForQuery.specie],
	);

	const { data: progressData } = usePhytosanitaryProgramProgress(queryFilters, {
		enabled: isEnabled,
	});

	const totalProgress = useMemo(() => {
		if (!progressData?.data || progressData.data.length === 0) {
			return 0;
		}

		const totals = progressData.data.reduce(
			(acc, program) => {
				acc.totalApplications += program.total_applications || 0;
				acc.completedCount += program.completed_count || 0;
				return acc;
			},
			{ totalApplications: 0, completedCount: 0 },
		);

		if (totals.totalApplications === 0) {
			return 0;
		}

		return (totals.completedCount * 100) / totals.totalApplications;
	}, [progressData]);

	const totalSurface = useMemo(() => {
		if (!progressData?.data || progressData.data.length === 0) {
			return 0;
		}

		return progressData.data.reduce((sum, program) => sum + (program.total_area || 0), 0);
	}, [progressData]);

	return {
		progressData,
		totalProgress,
		totalSurface,
	};
};
